import api from '@/api';
import { IBank } from '@/models/banks';

export async function getBanks(): Promise<IBank[]> {
  const {
    data: { banks },
  } = await api.get('/banks');
  return banks as IBank[];
}
